export default __webpack_public_path__ + "static/media/banner1.53b889bd.jpg";